import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { loginSDK } from '@eureka/shared/login-sdk';
import { Logger } from '@patsnap/tahiti-core';

/**
 * 判断是否运行在 iframe 中
 * @returns
 */
export function isInIframe() {
  return window.self !== window.top;
}

function stopper() {
  if (window.location.search.indexOf('noraven') > -1) {
    throw new Error('Local stop redirect');
  }
}

export interface ShareUnauthenticatedHandler {
  handle(): void;
}

export const ShareUnauthenticatedHandler = Symbol('ShareUnauthenticatedHandler');

@injectable()
export class ShareUnauthenticatedHandlerImpl implements ShareUnauthenticatedHandler {
  // eslint-disable-next-line no-useless-constructor
  constructor(
    @inject(Logger)
    private readonly _logger: Logger,
  ) {}

  get win() {
    return isInIframe() ? window.parent : window;
  }

  private _isInAiAgentFlowIframe() {
    return isInIframe() && this.win.location.href.includes('ai/agent-flow/');
  }

  handle(): void {
    if (this._isInAiAgentFlowIframe()) {
      this._logger.warn('运行在 AI Agent Flow 中，调用父级页面 401 策略');
      this._callIframeParent();
    } else {
      this._logger.warn('运行在非 iframe 中，打开登录');
      stopper();
      loginSDK.open().then(() => {
        this.win.location.reload();
      });
    }
  }

  /**
   * 调用iframe父级页面的方法
   */
  private _callIframeParent() {
    if (isInIframe()) {
      window.parent.postMessage(JSON.stringify({ type: 'unauthenticated' }), '*');
    }
  }
}
